import React, { useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

// --- ICONS ---
const PhoneIcon = () => <svg className="w-4 h-4 mr-1.5 text-white" fill="currentColor" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>;
const ArrowRight = () => <svg className="w-4 h-4 ml-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>;
const DropdownIcon = () => ( <svg className="w-4 h-4 ml-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg> );

// --- SOCIAL ICON COMPONENT ---
const SocialIcon = ({ path, href, size = "w-8 h-8" }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className={`${size} rounded-full bg-white text-orange-500 flex items-center justify-center hover:bg-orange-100 transition-colors`}>
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d={path}/></svg>
    </a>
);
const fbPath = "M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z";
const instaPath = "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z";
const ytPath = "M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z";

// --- REFINED MOBILE MENU (Drawer) ---
const MobileMenu = ({ navLinks, closeMenu }) => {
    const [openDropdown, setOpenDropdown] = useState(null);
    
    const toggleDropdown = (linkName) => {
        setOpenDropdown(openDropdown === linkName ? null : linkName);
    };

    return (
        <div className="fixed inset-0 z-50 lg:hidden">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={closeMenu}></div>
            
            {/* Drawer Container */}
            <div className="absolute right-0 top-0 h-full w-[85%] bg-white shadow-2xl overflow-y-auto animate-slide-in">
                <div className="h-1.5 w-full bg-orange-700"></div>
                
                {/* Header inside Menu */}
                <div className="p-6">
                    <div className="flex justify-between items-start mb-2">
                         <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">Since 2009</span>
                         <button onClick={closeMenu} className="text-3xl font-light text-gray-800 leading-none px-2">&times;</button>
                    </div>
                    <div className="flex items-center gap-4 mt-2">
                        <img src={logo} alt="JNJ Logo" className="h-16 w-auto object-contain" />
                        <div className="flex flex-col text-left">
                            <h1 className="text-2xl font-serif font-extrabold text-[#652c0b] leading-none">
                                JACK N JILL
                            </h1>
                            <h2 className="text-sm font-serif font-bold text-[#652c0b] leading-tight mt-1">
                                Senior Secondary School
                            </h2>
                            <span className="text-[10px] text-gray-400 font-medium mt-1 uppercase tracking-tight">Affiliated to RBSE</span>
                        </div>
                    </div>
                    <div className="w-full h-px bg-gray-100 mt-6"></div>
                </div>

                {/* Navigation Links */}
                <nav className="px-6 pb-10 space-y-1">
                    {navLinks.map((link) => (
                        <div key={link.name} className="border-b border-gray-50 pb-1">
                            
                            {/* LOGIC CHANGE: Check if it has subsections first */}
                            {link.subsections ? (
                                // OPTION A: It is a Dropdown (Make whole row a button)
                                <button 
                                    onClick={() => toggleDropdown(link.name)}
                                    className="w-full flex justify-between items-center py-3 text-left group"
                                >
                                    <span className={`text-base font-bold transition-colors ${openDropdown === link.name ? 'text-orange-600' : 'text-slate-800'}`}>
                                        {link.name}
                                    </span>
                                    <svg 
                                        className={`w-4 h-4 transform transition-transform duration-200 ${openDropdown === link.name ? 'rotate-180 text-orange-600' : 'text-gray-400'}`} 
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"/>
                                    </svg>
                                </button>
                            ) : (
                                // OPTION B: It is a Standard Link (Make whole row clickable)
                                <Link 
                                    to={link.path} 
                                    onClick={closeMenu} 
                                    className="block w-full py-3 text-base font-bold text-slate-800 hover:text-orange-600"
                                >
                                    {link.name}
                                </Link>
                            )}

                            {/* Dropdown Content */}
                            {link.subsections && openDropdown === link.name && (
                                <div className="bg-orange-50/50 rounded-lg p-3 mb-2 space-y-2 border-l-2 border-orange-200 ml-2">
                                    {link.subsections.map((subLink) => (
                                        <Link 
                                            key={subLink.name} 
                                            to={subLink.path} 
                                            onClick={closeMenu} 
                                            className="block text-sm text-gray-600 hover:text-orange-600 font-medium py-1"
                                        >
                                            {subLink.name}
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                    
                    <div className="pt-6">
                        <Link to="/contact-us" onClick={closeMenu} className="block w-full text-center bg-orange-500 text-white py-3 rounded-lg font-bold uppercase tracking-wide shadow-md active:scale-95 transition-transform">
                            Contact Us
                        </Link>
                    </div>
                </nav>
            </div>
        </div>
    );
};
// --- CORRECTED FULL HEADER COMPONENT ---

const Navbar = () => {
    // --- FIX: ALL STATE AND DATA IS NOW DEFINED IN THE PARENT COMPONENT ---
    const [openDropdown, setOpenDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const navLinks = [
    {
        name: 'About Us',
        path: '/about-us',
        subsections: [
            { name: 'About JNJ', path: '/about-us#about-evolution' },
            { name: 'Evolution of JNJ', path: '/about-us#about-evolution' },
            { name: 'Our Vision, Mission & Value', path: '/about-us#vision-mission' },
            { name: 'Hon. Director', path: '/about-us#director' },
            { name: 'Our Principal', path: '/about-us#principal' },
            { name: 'Our Team ', path: '/about-us#team' }
        ]
    },
    {
        name: 'Campus',
        path: '/campus',
        subsections: [
            { name: 'Smart Classroom', path: '/campus#smart-classroom' },
            { name: 'Digital Studio', path: '/campus#digital-studio' },
            { name: 'Library', path: '/campus#library' },
            { name: 'Laboratories', path: '/campus#laboratories' },
            { name: 'Multi Activity Room', path: '/campus#multi-activity-room' },
            { name: 'Music Studio', path: '/campus#music-studio' },
            { name: 'Dance / Drama Room', path: '/campus#dance-drama-room' },
            { name: 'Sports Arena', path: '/campus#sports-arena' },
            { name: 'Kids Zone', path: '/campus#kids-zone' },
            { name: 'Transport', path: '/campus#transport' },
            { name: 'Safety & Security', path: '/campus#safety-security' },
            { name: 'Art & Craft', path: '/campus#art-craft' }
        ]
    },
    {
        name: 'Student Life',
        path: '/life-at-jnj',
        subsections: [
            { name: 'Admission Criteria', path: '/life-at-jnj#admission' },
            { name: 'Scholarship', path: '/life-at-jnj#scholarship' },
            { name: 'School Timings', path: '/life-at-jnj#timings' },
            { name: 'Scholar Uniform', path: '/life-at-jnj#uniform' },
            { name: 'Houses', path: '/life-at-jnj#houses' },
            { name: 'Code of Conduct', path: '/life-at-jnj#code-of-conduct' }
        ]
    },
    {
        name: 'Curricular',
        path: '/curricular',
        subsections: [
            { name: 'Curriculum', path: '/curricular#curriculum' },
            { name: 'Assessment Policy', path: '/curricular#assessment-policy' },
            { name: 'Teaching Methodology', path: '/curricular#teaching-methodology' },
            { name: 'Book List', path: '/curricular#book-list' },
            { name: 'Learning Gateways', path: '/curricular#learning-gateways' }
        ]
    },
    {
        name: 'Co-curricular',
        path: '/co-curricular',
        subsections: [
            { name: 'Activities @ JNJ', path: '/co-curricular#activities' },
            { name: 'Festivals', path: '/co-curricular#festivals' },
            { name: 'Birthday Celebration', path: '/co-curricular#birthdays' },
            { name: 'Thematic Color Celebration', path: '/co-curricular#color-celebration' },
            { name: 'Morning Assembly', path: '/co-curricular#assembly' }
        ]
    },
    {
        name: 'Gallery',
        path: '/gallery',
        subsections: [
            { name: 'Photos (Session Wise)', path: '/gallery#photos' },
            { name: 'Videos (Session Wise)', path: '/gallery#videos' },
            { name: 'Art Gallery', path: '/gallery#art' },
            { name: 'Group Photos', path: '/gallery#groups' }
        ]
    },
    {
        name: 'Others',
        path: '#',
        subsections: [
            { name: 'Board Results', path: '/board-results' },
            { name: 'Testimonials', path: '/testimonials' },
            { name: 'Alumni', path: '/alumni' },
            { name: 'School Blogs', path: '/blog' },
            { name: 'Suggestion', path: '/feedback' },
            { name: 'Join Us', path: '/join-us' },
            { name: 'FAQ', path: '/faq' },
            { name: 'Contact Us', path: '/contact-us' }
        ]
    }
];

    const isLinkActive = (link) => (link.path === '#' ? link.subsections?.some(sub => sub.path === location.pathname) : location.pathname === link.path);
     
    const handleDesktopDropdownClick = (path) => {
        // First, close the dropdown
        setOpenDropdown(null);
        
        // Then, navigate after a short delay
        setTimeout(() => {
            navigate(path);
        }, 150); // 150ms is plenty of time
    };

    return (
    <header className="font-sans shadow-sm" onMouseLeave={() => setOpenDropdown(null)}>
        
        {/* --- DESKTOP HEADER --- */}
        <div className="hidden lg:block border-t-4 border-orange-700">
            {/* ... (Your existing, correct desktop JSX code) ... */}
             <div className="bg-[#f37021] text-white py-2">
                <div className="max-w-7xl mx-auto px-16 flex justify-between items-center">
                    <div className="flex items-center gap-6">
                        <div className="flex gap-2"><SocialIcon path={fbPath} href="https://www.facebook.com/profile.php?id=100064232791284" /><SocialIcon path={instaPath} href="https://www.instagram.com/jacknjillschool/?hl=en" /><SocialIcon path={ytPath} href="https://www.youtube.com/@jacknjillschool.1" /></div>
                        <div className="flex items-center gap-4 text-sm font-semibold"><span className="flex items-center"><PhoneIcon /> 99820-69996</span><span className="flex items-center"><PhoneIcon /> 0291-2554466</span></div>
                    </div>
                    <Link 
    to="/admission-inquiry" 
    className="bg-white text-orange-600 px-5 py-2 rounded-full text-sm font-bold flex items-center hover:bg-orange-100 transition-colors"
>
    Admissions 2026-27 <ArrowRight />
</Link>
                </div>
            </div>
            <div className="max-w-7xl mx-auto px-16">
                <div className="flex items-center justify-between py-4">
                     <Link to="/"><img src={logo} alt="JNJ Logo" className="h-28 w-auto object-contain" /></Link>
                     {/* --- CHANGES APPLIED TO THIS BLOCK --- */}
                    <div className="text-center"> 
                        <span className="text-sm font-bold text-gray-400 tracking-wider uppercase">Since 2009</span>
                        {/* REMOVED `font-serif` to use the default Poppins font */}
                        <h1 className="text-5xl font-bold text-[#652c0b] leading-none mt-1">
                            JACK N JILL
                        </h1>
                        {/* REMOVED `font-serif` to use the default Poppins font */}
                        <h2 className="text-3xl font-semibold text-[#652c0b]">
                            Senior Secondary School
                        </h2>
                        <p className="text-sm text-gray-400 mt-2 uppercase tracking-tight text-center">Affiliated to RBSE</p>
                    </div>
                    <div className="flex flex-col items-center justify-center w-32 h-32 bg-orange-500 border-4 border-orange-500 rounded-full text-white p-2 text-center shadow-md">
                        <span className="text-5xl font-black leading-none">17</span>
                        <span className="text-xs font-bold leading-tight uppercase mt-1">Years of</span>
                        <span className="text-xs font-bold leading-tight uppercase">Excellence</span>
                    </div>
                </div>
                <nav className="flex justify-between items-center h-20 border-t border-gray-100">
                    <div className="flex items-center space-x-8">
                        <NavLink to="/" className={({isActive}) => `text-base font-medium transition-colors ${isActive ? 'text-orange-500' : 'text-slate-800 hover:text-orange-500'}`}>Home</NavLink>
                        {navLinks.map((link) => (
                        <div key={link.name} className="relative" onMouseEnter={() => setOpenDropdown(link.name)}>
                            <Link to={link.path === '#' ? '#' : link.path} onClick={(e) => { if(link.path === '#') e.preventDefault(); }} className={`flex items-center text-base font-medium transition-colors ${isLinkActive(link) ? 'text-orange-500' : 'text-slate-800 hover:text-orange-500'}`}>
                                {link.name}
                                {link.subsections && <DropdownIcon />}
                            </Link>
                            {openDropdown === link.name && link.subsections && (
                            <div className="absolute top-full left-0 mt-4 w-56 bg-white rounded-md shadow-xl py-2 z-50 border border-gray-100">
                                {link.subsections.map((subLink) => (<a 
                                    key={subLink.name} 
                                    href={subLink.path} 
                                    className={`block px-4 py-2 text-sm hover:bg-gray-100 hover:text-orange-500 ${location.pathname === subLink.path ? 'text-orange-500 bg-gray-50' : 'text-gray-700'}`} 
                                    onClick={(e) => {
                                        e.preventDefault(); // Prevent default browser navigation
                                        handleDesktopDropdownClick(subLink.path);
                                    }}
                                >
                                    {subLink.name}
                                </a>))}
                            </div>
                            )}
                        </div>
                        ))}
                    </div>
                    <NavLink to="/contact-us" className={({ isActive }) => `font-bold py-3 px-8 rounded-md transition-all text-base ${isActive ? 'bg-orange-600 text-white' : 'bg-orange-500 text-white hover:bg-orange-600'}`}>Contact Us</NavLink>
                </nav>
            </div>
        </div>

     
      
         {/* --- UPDATED MOBILE HEADER --- */}
        <div className="lg:hidden border-t-4 border-orange-700">
            {/* Mobile Top Bar */}
            <div className="bg-[#f37021] text-white py-2 px-4 flex justify-between items-center">
                <div className="flex gap-2">
                    <SocialIcon size="w-7 h-7" path={fbPath} href="https://www.facebook.com/profile.php?id=100064232791284" />
                    <SocialIcon size="w-7 h-7" path={instaPath} href="https://www.instagram.com/jacknjillschool/?hl=en" />
                    <SocialIcon size="w-7 h-7" path={ytPath} href="https://www.youtube.com/@jacknjillschool.1" />
                </div>
                <Link 
    to="/admission-inquiry" 
    className="bg-white text-orange-600 px-5 py-2 rounded-full text-sm font-bold flex items-center hover:bg-orange-100 transition-colors"
>
    Admissions 2026-27 <ArrowRight />
</Link>
            </div>

            {/* Mobile Main Bar */}
            <div className="bg-white p-4 flex items-center justify-between border-b border-gray-100">
                <div className="flex items-center gap-3">
                    <Link to="/"><img src={logo} alt="JNJ Logo" className="h-16 w-auto object-contain" /></Link>
                    <div>
                        <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Since 2009</span>
                        <h1 className="text-xl font-serif font-extrabold text-[#652c0b] leading-none">JACK N JILL</h1>
                        <h2 className="text-sm font-serif font-bold text-[#652c0b] leading-tight">Senior Secondary School</h2>
                        <span className="text-[10px] text-gray-400 font-medium uppercase tracking-tight">Affiliated to RBSE</span>
                    </div>
                </div>
                
                <button 
                    onClick={() => setIsMobileMenuOpen(true)} 
                    className="p-2 rounded-lg bg-orange-50 text-orange-600" 
                    aria-label="Open menu"
                >
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                </button>
            </div>
        </div>

        {isMobileMenuOpen && <MobileMenu navLinks={navLinks} closeMenu={() => setIsMobileMenuOpen(false)} />}
    </header>
  );
};

export default Navbar;
